import React from "react";
import AboutWelcomeEventDescription from "./AboutWelcomeEventDescription";
import AboutWelcomeEventAgenda from "./AboutWelcomeEventAgenda";
import AboutWelcomeEventOrganizer from "./AboutWelcomeEventOrganizer";

const AboutWelcomeEvent = () => {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-[2.5rem] p-8 md:p-14 shadow-2xl border border-slate-100 dark:border-slate-800">
      {/* Header */}
      <h3 className="text-3xl md:text-4xl font-black text-slate-900 dark:text-white mb-16 text-center uppercase tracking-tight">
        About <span className="text-blue-600">Siloam Cardiac Summit</span>
      </h3>

      {/* 
          LAYOUT GRID CUSTOM: 
          - Grid-cols-1 (Mobile): Agenda otomatis ke bawah Description.
          - lg:grid-cols-3 (Desktop): Membagi layar jadi 3 bagian.
      */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-16 items-start mb-20">
        
        {/* Description: Mengambil 2 dari 3 kolom agar lebih LEBAR */}
        <div className="lg:col-span-2 text-left">
          <AboutWelcomeEventDescription />
        </div>

        {/* Agenda: Mengambil 1 kolom sisanya */}
        <div className="lg:col-span-1 w-full">
          <AboutWelcomeEventAgenda />
        </div>
      </div>

      {/* Organizer / Network Section */}
      <div className="pt-12 border-t border-slate-100 dark:border-slate-800">
        <h4 className="text-center font-black text-slate-400 dark:text-slate-600 mb-10 uppercase tracking-[0.4em] text-[10px]">
          Our Network
        </h4>
        <AboutWelcomeEventOrganizer />
      </div>
    </div>
  );
};

export default AboutWelcomeEvent;